import type { ExtractDispatchFromModel, WidgetEffectParams } from '@swf/core/store';
import type { GetScheduledTournamentResponse } from '@swf/generated/types/api/v1-preview/SwHomeGames';
import type { HomeGamesWidgetModel } from '@swf/poker';
import { PKR_LOADERS } from '@swf/poker';

export const fetchRegisteredTournaments = async (
  { clubId }: { clubId?: number } = {},
  { request, dispatch, widget: { id } }: WidgetEffectParams<void>
) => {
  const widgetDispatch: ExtractDispatchFromModel<HomeGamesWidgetModel> = dispatch[id];
  const loaderName = PKR_LOADERS.registeredTournaments;
  widgetDispatch.setLoading({ isLoading: true, loaderName });

  const body = clubId ? { clubId } : {};

  try {
    const {
      body: { success, scheduledTournamentReply }
    } = await request<GetScheduledTournamentResponse>({
      service: '/api/v1-preview/homegames/scheduled/tournaments',
      body
    });

    if (success && scheduledTournamentReply?.tourns) {
      widgetDispatch.setRegisteredTournaments({
        response: scheduledTournamentReply?.tourns
      });
    }
  } finally {
    widgetDispatch.setLoading({ isLoading: false, loaderName });
  }
};
